import { put, call, takeLatest } from "redux-saga/effects";
import { sensorTotalConsumptionConstants } from "../../constants/client";
import { callAPI } from "../commonApiCall";
import apiURLs from "../../config/url-config";
import { sensorTotalConsumption, alertActions } from "../../actions";

function* totalConsumption(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.sensorsUrl.totalData,
      action.payload
    );

    if (data.status === true) {
      yield put(
        sensorTotalConsumption.totalConsumptionSuccess({
          data: data.data,
        })
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
  }
}

export function* sensorTotalConsumptionSaga() {
  yield takeLatest(sensorTotalConsumptionConstants.TOTAL_CONSUMPTION_REQUEST, totalConsumption);
}
